import { RolexContainer } from './Container'
import { Text } from '@components/rolex-ui/Text'
import { cn } from '@lib/cn'
import { FC } from 'react'

type RolexQuoteProps = {
  className?: string
  quote: string
  author: string
  spacing?: 'none' | 'small' | 'large'
  spacingType?: 'padding' | 'margin'
}

export const RolexQuote: FC<RolexQuoteProps> = ({
  quote,
  author,
  className,
  spacing = 'none',
  spacingType = 'padding',
}) => {
  return (
    <RolexContainer
      className={cn(
        `grid w-full grid-cols-6 gap-2 md:grid-cols-12`,
        spacingType === 'padding' &&
          (spacing === 'small' ? 'pb-[40px]' : spacing === 'large' ? 'pb-[60px] lg:pb-[90px]' : ''),
        spacingType === 'margin' &&
          (spacing === 'small' ? 'mb-[40px]' : spacing === 'large' ? 'mb-[60px] lg:mb-[90px]' : ''),
        className,
      )}
    >
      <div className="col-span-6 flex flex-col items-start md:col-span-8 md:col-start-3 lg:col-span-6 lg:col-start-4">
        <Text variant="quote" className="mb-5">
          {quote}
        </Text>
        <Text variant="body20" weight="light">
          {author}
        </Text>
      </div>
    </RolexContainer>
  )
}
